<template>
    <client-page>
        <page-section class="page-section--first page-section--last">
            <template slot="tit">로그인</template>

            <div class="mw-400px mx-auto">
                <v-row class="row--sm">
                    <v-col cols="12">
                        <v-text-field v-model="username" v-bind="{ ...attrs_input }" :dense="false" type="email" placeholder="아이디" />
                    </v-col>
                    <v-col cols="12">
                        <v-text-field v-model="password" v-bind="{ ...attrs_input }" :dense="false" type="password" name="" value="" placeholder="비밀번호" @keydown.enter="login" />
                    </v-col>
                    <v-col cols="12">
                        <v-checkbox v-model="remember" color="primary" label="아이디저장" :value="true" hide-details />
                    </v-col>
                </v-row>

                <div class="btn-wrap">
                    <v-row class="row--sm">
                        <v-col cols="12">
                            <v-btn block color="primary" class="v-size--xx-large" @click="login">로그인</v-btn>
                        </v-col>
                        <v-col cols="12">
                            <div class="divider-group text-center">
                                <ul class="grey--text">
                                    <li>
                                        <router-link to="/login/find-id/">아이디 찾기</router-link>
                                    </li>
                                    <li>
                                        <router-link to="/login/find-password/">비밀번호 찾기</router-link>
                                    </li>
                                    <li>
                                        <router-link to="/join">회원가입</router-link>
                                    </li>
                                </ul>
                            </div>
                        </v-col>
                    </v-row>
                </div>
            </div>

            <!-- 회원가입/소셜버튼 -->
            <!-- <div class="login-row">
                <kakao-login client_id="">카카오 계정으로 로그인</kakao-login>
            </div>
            <div class="login-row">
                <naver-login client_id="">네이버 계정으로 로그인</naver-login>
            </div> -->
        </page-section>
    </client-page>
</template>

<script>
import { attrs_input } from "@/assets/variables";

import CryptoAES from "../../../plugins/crypto-aes";
import KakaoLogin from "../../../components/plugins/kakao/kakao-login.vue";
import NaverLogin from "../../../components/plugins/naver/naver-login.vue";

import ClientPage from "@/components/client/templates/client-page.vue";
import PageSection from "@/components/client/templates/page-section.vue";

export default {
    components: {
        KakaoLogin,
        NaverLogin,
        ClientPage,
        PageSection,
    },
    data: () => {
        return {
            username: "",
            password: "",

            remember: false,

            attrs_input,
        };
    },
    mounted() {
        this.init();
    },
    methods: {
        init: function() {
            if (this.$cookies.get("username")) this.username = this.$cookies.get("username");
            if (this.$cookies.get("password")) this.password = CryptoAES.decrypt(this.$cookies.get("password"));
        },
        async login() {
            try {
                await this.$store.dispatch("login", { username: this.username, password: this.password, remember: this.remember });

                if (this.remember) {
                    this.$cookies.set("username", this.username);
                    this.$cookies.set("password", CryptoAES.encrypt(this.password));
                }

                this.$router.push("/");
            } catch (error) {
                console.error(error);
                if (error.response) alert(error.response.data.message);
                else alert(error.message);
            }
        },
    },
};
</script>
